module.exports = __webpack_public_path__ + "img/sphere01-graph-black.54e638a7.png";